//@flow

import React, { Component } from 'react';
import uniqueId from 'lodash/uniqueId';

import EditButton from '../../NewEditButton';

import { componentNames as editorNames } from '../../TrekOverviewModal';

type props = {
  highlights: Array<string>,
};

class Highlights extends Component<props> {
  render() {
    const { highlights } = this.props;
    return (
      <div>
        <h2>
          HIGHLIGHTS
          <span>
            <EditButton editorName={editorNames.HighlightsEditor} openModal={false} />
          </span>
        </h2>
        {highlights && (
          <ul
            className="highlight-list"
            id="sd-trek-highlights"
            data-trek-highlights={highlights.join(' ')}
          >
            {highlights
              .filter(hightlight => hightlight)
              .map(highlight => (
                <li key={uniqueId('highlights')}>{highlight}</li>
              ))}
          </ul>
        )}
      </div>
    );
  }
}

export default Highlights;



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Viewers/Highlights/Highlights.jsx